import { createContext, useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type DynamicPageContext = Record<string, any>;

const PageContext = createContext<{
    dataContext: DynamicPageContext;
    setDataContext: (data: DynamicPageContext) => void;
    updateDataContext: (data: DynamicPageContext) => void;
}>({
    dataContext: {},
    setDataContext: () => { },
    updateDataContext: () => { },
});

export const usePageContext = () => useContext(PageContext);

export const PageProvider = ({ children }: { children: React.ReactNode }) => {
    const [dataContext, setDataContext] = useState<DynamicPageContext>({});
    const location = useLocation();

    useEffect(() => {
        // Reset context on route change
        setDataContext({});
    }, [location.pathname]);

    // Optional: merge/update utility
    const updateDataContext = (data: DynamicPageContext) =>
        setDataContext(prev => ({ ...prev, ...data }));

    return (
        <PageContext.Provider value={{ dataContext, setDataContext, updateDataContext }}>
            {children}
        </PageContext.Provider>
    );
};
